import {memo} from 'react';

import PropTypes from 'prop-types';

import useIntlFormat from '@/hooks/useIntlFormat';

import './IntlMessage.scss';

function IntlMessage({id, value, className, defaultMessage}) {
  const {formatHTMLMessage} = useIntlFormat();
  return (
    <p className={`intl-message ${className}`}>
      {formatHTMLMessage(
        {id, defaultMessage: defaultMessage || id},
        {
          ...value,
        },
      )}
    </p>
  );
}

IntlMessage.propTypes = {
  id: PropTypes.string,
  value: PropTypes.object,
  className: PropTypes.string,
  defaultMessage: PropTypes.string,
};

IntlMessage.defaultProps = {
  id: '',
  value: {},
  className: '',
  defaultMessage: '',
};

export default memo(IntlMessage);
